import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Compliance from './pages/Compliance';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SmsTerms from './pages/SmsTerms';
import Contact from './pages/Contact';
import OptOut from './pages/OptOut';
import Support from './pages/Support';
import BusinessVerification from './pages/BusinessVerification';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/sms-terms" element={<SmsTerms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/opt-out" element={<OptOut />} />
            <Route path="/support" element={<Support />} />
            <Route path="/verification" element={<BusinessVerification />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;